import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class ProgramVehiclesTaskCancellationFeesTableRowComponent implements IController {

  cancellationFee: { status: string, value: { type: string, value: number }, type: string };
  index: number;
  statuses: string[];
  excludedStatuses: string[];
  isEdit: boolean;
  onUpdate: Function;
  onDelete: Function;

  public currencySymbol: string;
  public excludedStatusesKeys: {};
  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.currencySymbol = this.splitService.getCurrencySymbol();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if(changes.excludedStatuses && changes.excludedStatuses) {
      this.excludedStatusesKeys = {};
      this.excludedStatuses?.forEach(s => {
        this.excludedStatusesKeys[s] = true;
      })
    }
  }

  onChangeFeeType(type) {
    this.cancellationFee.value.type = type;
    this.onUpdate({cancellationFee: this.cancellationFee, cancellationFeeIndex: this.index});
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programVehiclesTaskCancellationFeesTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      cancellationFee: '<',
      index: '<',
      statuses: '<?',
      excludedStatuses:'<',
      isEdit: '<',
      onUpdate: '&',
      onDelete: '&'
    },
    template: require('./program-vehicles-task-cancellation-fees-table-row.html').default,
    controller: ProgramVehiclesTaskCancellationFeesTableRowComponent
  });
